(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zius-metal-picker')) {
    customElements.define('zius-metal-picker', class extends HTMLElement {
      connectedCallback() {
        this.source = this.nextElementSibling;
        if (!this.source || !this.source.classList.contains('zius-metal-source')) return;
        this.picker = this.closest('variant-picker');
        this.typeButtons = Array.from(this.querySelectorAll('[data-metal-type]'));
        this.colorButtons = Array.from(this.querySelectorAll('[data-metal-color]'));
        this.typeStatus = this.querySelector('[id^="MetalTypeStatus-"]');
        this.colorStatus = this.querySelector('[id^="MetalColorStatus-"]');
        this.unavailableText = this.dataset.unavailableText;
        this.addEventListener('click', this.handleClick.bind(this));
        this.onSelectionChange = () => queueMicrotask(() => this.sync());
        this.picker.addEventListener('change', this.onSelectionChange);
        this.sync();
      }
      getType(value) {
        if (value.includes('925')) return '925 Silver';
        if (value.includes('10K')) return '10K Gold';
        if (value.includes('14K')) return '14K Gold';
        if (value.includes('18K')) return '18K Gold';
        if (value.toLowerCase().includes('platinum')) return 'Platinum';
        return '';
      }
      getColor(value) {
        if (value.toLowerCase().includes('rose')) return 'Rose';
        if (value.toLowerCase().includes('yellow')) return 'Yellow';
        return 'White';
      }
      get inputs() { return Array.from(this.source.querySelectorAll('input[type="radio"]')); }
      disconnectedCallback() {
        if (this.picker) this.picker.removeEventListener('change', this.onSelectionChange);
      }
      isAvailable(input) {
        const product = this.picker && window._themeProducts && window._themeProducts[this.picker.dataset.productId];
        const groups = this.picker ? Array.from(this.picker.querySelectorAll(".m-product-option__inner")) : [];
        const index = groups.findIndex((group) => group.contains(input));
        if (product && Array.isArray(product.variants) && index >= 0) {
          const selected = groups.map((group) => {
            const field = group.querySelector('select, input[type="radio"]:checked');
            return field ? field.value : null;
          });
          return product.variants.some((variant) => variant.available && variant.options.every((value, i) => value === (i === index ? input.value : selected[i])));
        }
        return !input.disabled && !input.classList.contains('disabled');
      }
      findInput(type, color) {
        return this.inputs.find((input) => this.getType(input.value) === type && this.getColor(input.value) === color && this.isAvailable(input));
      }
      handleClick(event) {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const checked = this.inputs.find((input) => input.checked) || this.inputs[0];
        const currentType = checked ? this.getType(checked.value) : '';
        const currentColor = checked ? this.getColor(checked.value) : 'White';
        let match;
        if (button.dataset.metalType) {
          match = this.findInput(button.dataset.metalType, currentColor);
          match ||= this.inputs.find((input) => this.getType(input.value) === button.dataset.metalType && this.isAvailable(input));
        } else {
          match = this.findInput(currentType, button.dataset.metalColor);
        }
        if (match) match.click();
      }
      sync() {
        const checked = this.inputs.find((input) => input.checked) || this.inputs[0];
        if (!checked) return;
        const selectedType = this.getType(checked.value);
        const selectedColor = this.getColor(checked.value);
        this.typeButtons.forEach((button) => {
          const type = button.dataset.metalType;
          button.setAttribute('aria-pressed', String(type === selectedType));
          button.disabled = !this.findInput(type, selectedColor) && !this.inputs.some((input) => this.getType(input.value) === type && this.isAvailable(input));
          button.setAttribute('aria-disabled', String(button.disabled));
          button.title = button.disabled ? `${button.textContent.trim()}: ${this.unavailableText} (${selectedColor})` : '';
        });
        this.colorButtons.forEach((button) => {
          const color = button.dataset.metalColor;
          button.setAttribute('aria-pressed', String(color === selectedColor));
          button.disabled = !this.findInput(selectedType, color);
          button.setAttribute('aria-disabled', String(button.disabled));
          button.title = button.disabled ? `${button.textContent.trim()}: ${this.unavailableText} (${selectedType})` : '';
        });
        if (this.typeStatus) this.typeStatus.textContent = `${selectedType}, ${selectedColor}`;
        if (this.colorStatus) this.colorStatus.textContent = `${selectedColor}, ${selectedType}`;
      }
    });
  }

  if (!customElements.get('zius-legacy-color-picker')) {
    customElements.define('zius-legacy-color-picker', class extends HTMLElement {
      connectedCallback() {
        this.source = this.nextElementSibling;
        if (!this.source || !this.source.classList.contains('zius-color-source')) return;
        this.picker = this.closest('variant-picker');
        this.buttons = Array.from(this.querySelectorAll('[data-metal-color]'));
        this.status = this.querySelector('[id^="LegacyMetalColorStatus-"]');
        this.unavailableText = this.dataset.unavailableText;
        this.addEventListener('click', this.handleClick.bind(this));
        this.onSelectionChange = () => queueMicrotask(() => this.sync());
        this.picker.addEventListener('change', this.onSelectionChange);
        this.sync();
      }
      getColor(value) {
        const normalized = value.toLowerCase();
        if (normalized.includes('rose')) return 'Rose';
        if (normalized.includes('yellow') || normalized === '925-silver') return 'Yellow';
        return 'White';
      }
      get inputs() { return Array.from(this.source.querySelectorAll('input[type="radio"]')); }
      disconnectedCallback() {
        if (this.picker) this.picker.removeEventListener('change', this.onSelectionChange);
      }
      isAvailable(input) {
        const product = this.picker && window._themeProducts && window._themeProducts[this.picker.dataset.productId];
        const groups = this.picker ? Array.from(this.picker.querySelectorAll(".m-product-option__inner")) : [];
        const index = groups.findIndex((group) => group.contains(input));
        if (product && Array.isArray(product.variants) && index >= 0) {
          const selected = groups.map((group) => {
            const field = group.querySelector('select, input[type="radio"]:checked');
            return field ? field.value : null;
          });
          return product.variants.some((variant) => variant.available && variant.options.every((value, i) => value === (i === index ? input.value : selected[i])));
        }
        return !input.disabled && !input.classList.contains('disabled');
      }
      findInput(color) {
        return this.inputs.find((input) => this.getColor(input.value) === color && this.isAvailable(input));
      }
      handleClick(event) {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const match = this.findInput(button.dataset.metalColor);
        if (match) match.click();
      }
      sync() {
        const checked = this.inputs.find((input) => input.checked) || this.inputs[0];
        const selectedColor = checked ? this.getColor(checked.value) : 'White';
        this.buttons.forEach((button) => {
          const color = button.dataset.metalColor;
          button.setAttribute('aria-pressed', String(color === selectedColor));
          button.disabled = !this.findInput(color);
          button.setAttribute('aria-disabled', String(button.disabled));
          button.title = button.disabled ? `${button.textContent.trim()}: ${this.unavailableText}` : '';
        });
        if (this.status) this.status.textContent = selectedColor;
      }
    });
  }

  document.addEventListener('change', (event) => {
    const field = event.target.closest('[data-option-name]');
    if (!field || field.dataset.optionName.toLowerCase() !== 'color') return;
    const label = field.querySelector('[data-zius-color-selected]');
    if (!label) return;
    const value = event.target.value.toLowerCase();
    queueMicrotask(() => {
      label.textContent = value.includes('rose') ? 'Rose' : value.includes('yellow') || value === '925-silver' ? 'Yellow' : 'White';
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ring-size-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zius-ring-size')) {
  customElements.define('zius-ring-size', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.dialog = this.querySelector('[data-size-guide-dialog]');
      this.querySelector('[data-size-guide-open]')?.addEventListener('click', () => this.dialog?.showModal(), {signal:this.controller.signal});
      this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close(), {signal:this.controller.signal});
      this.dialog?.addEventListener('click', event => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, {signal:this.controller.signal});
      document.addEventListener('submit', event => {
        const form = event.target;
        if (form.id !== this.dataset.formId && form.id !== this.dataset.stickyId) return;
        const select = this.querySelector('select');
        if (!select.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          select.scrollIntoView({block:'center'});
          select.focus();
          select.reportValidity();
          return;
        }
        if (form.id === this.dataset.stickyId) {
          let field = form.querySelector('[name="properties[Ring Size (US)]"]');
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'properties[Ring Size (US)]';
            form.appendChild(field);
          }
          field.value = select.value;
        }
      }, {capture:true, signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zius-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zius-coupon')) {
  customElements.define('zius-coupon', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const input = this.querySelector('input');
        const code = input.value.trim();
        if (!code) { input.focus(); return; }
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        button.disabled = true;
        status.textContent = '';
        try {
          const beforeResponse = await fetch(this.dataset.root + 'cart.js');
          if (!beforeResponse.ok) throw new Error();
          const before = await beforeResponse.json();
          if (!before.item_count) { status.textContent = this.dataset.empty; return; }
          const codes = (before.discount_codes || []).map(entry => entry.code);
          if (!codes.some(value => value.toLowerCase() === code.toLowerCase())) codes.push(code);
          const response = await fetch(this.dataset.root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
          if (!response.ok) throw new Error();
          const cart = await response.json();
          const applied = (cart.discount_codes || []).some(entry => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable);
          status.textContent = applied ? this.dataset.success : this.dataset.invalid;
        } catch (error) { status.textContent = this.dataset.error; }
        finally { button.disabled = false; }
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zius-personalization"] && !Shopify.designMode) return;
  try {
    function connectZiusPersonalization(root) {
    root.querySelectorAll('[data-zius-personalization]').forEach((wrapper) => {
      if (wrapper.dataset.ziusPersonalizationConnected) return;

      const choice = wrapper.querySelector('[data-zius-personalization-choice]');
      const engraving = wrapper.querySelector('[data-zius-personalization-engraving]');
      const input = wrapper.querySelector('[data-zius-personalization-input]');
      const counter = wrapper.querySelector('[data-zius-personalization-count]');
      const request = wrapper.querySelector('[data-zius-personalization-request]');
      const requestInput = wrapper.querySelector('[data-zius-personalization-request-input]');
      const requestCounter = wrapper.querySelector('[data-zius-personalization-request-count]');
      const productSection = wrapper.closest('.shopify-section') || document;
      const forms = productSection.querySelectorAll('form[action*="/cart/add"]');

      const syncFormProperties = () => {
        const hasEngraving = choice.value === 'Free engraving';
        const hasRequest = choice.value === 'Personalisation request';
        engraving.hidden = !hasEngraving;
        input.disabled = !hasEngraving;
        input.required = hasEngraving;
        request.hidden = !hasRequest;
        requestInput.disabled = !hasRequest;
        requestInput.required = hasRequest;

        if (!hasEngraving) {
          input.value = '';
          counter.textContent = '0';
        }

        if (!hasRequest) {
          requestInput.value = '';
          requestCounter.textContent = '0';
        }

        forms.forEach((form) => {
          let choiceCopy = form.querySelector('[data-zius-personalization-choice-copy]');
          let engravingCopy = form.querySelector('[data-zius-personalization-engraving-copy]');
          let requestCopy = form.querySelector('[data-zius-personalization-request-copy]');

          if (!choiceCopy) {
            choiceCopy = document.createElement('input');
            choiceCopy.type = 'hidden';
            choiceCopy.name = 'properties[Personalization]';
            choiceCopy.dataset.ziusPersonalizationChoiceCopy = 'true';
            form.appendChild(choiceCopy);
          }

          if (!engravingCopy) {
            engravingCopy = document.createElement('input');
            engravingCopy.type = 'hidden';
            engravingCopy.name = 'properties[Engraving text]';
            engravingCopy.dataset.ziusPersonalizationEngravingCopy = 'true';
            form.appendChild(engravingCopy);
          }

          if (!requestCopy) {
            requestCopy = document.createElement('input');
            requestCopy.type = 'hidden';
            requestCopy.name = 'properties[Personalisation details]';
            requestCopy.dataset.ziusPersonalizationRequestCopy = 'true';
            form.appendChild(requestCopy);
          }

          choiceCopy.value = choice.value;
          engravingCopy.value = hasEngraving ? input.value : '';
          engravingCopy.disabled = !hasEngraving;
          requestCopy.value = hasRequest ? requestInput.value : '';
          requestCopy.disabled = !hasRequest;
        });
      };

      choice.removeAttribute('name');
      input.removeAttribute('name');

      choice.addEventListener('change', syncFormProperties);
      input.addEventListener('input', () => {
        const cleanedValue = input.value.replace(/[^A-Za-z0-9 &'\.\-]/g, '');
        if (input.value !== cleanedValue) input.value = cleanedValue;
        counter.textContent = input.value.length;
        syncFormProperties();
      });
      requestInput.addEventListener('input', () => {
        requestCounter.textContent = requestInput.value.length;
        syncFormProperties();
      });

      syncFormProperties();
      wrapper.dataset.ziusPersonalizationConnected = 'true';
    });
  }

  connectZiusPersonalization(document);
  document.addEventListener('shopify:section:load', (event) => connectZiusPersonalization(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zius-sale-code"] && !Shopify.designMode) return;
  try {
    function connectZiusSaleCodes(root) {
    root.querySelectorAll('[data-zius-sale-code]').forEach((offer) => {
      if (offer.dataset.connected) return;

      const status = offer.querySelector('[data-zius-sale-status]');
      const note = offer.querySelector('[data-zius-sale-note]');
      const applyLink = offer.querySelector('[data-zius-sale-apply]');
      const removeButton = offer.querySelector('[data-zius-sale-remove]');
      const variantData = offer.querySelector('[data-zius-sale-variants]');
      const productSection = offer.closest('[id^="MainProduct-"]') || offer.closest('.shopify-section') || document;
      const variants = JSON.parse(variantData.textContent);
      let selectedVariantId = String(offer.dataset.initialVariant);
      let isDiscountApplied = false;

      const formatMoney = (cents) => {
        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format(cents / 100);
      };

      const getSelectedVariant = () => {
        const variantInput = productSection.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantInput?.value) selectedVariantId = String(variantInput.value);
        return variants.find((variant) => String(variant.id) === selectedVariantId) || variants[0];
      };

      const updateMainPrice = (applied, originalPrice, salePrice) => {
        const priceRoot = productSection.querySelector('[id^="Price-"] .m-price');
        if (!priceRoot) return;

        const regularWrap = priceRoot.querySelector('.m-price__regular');
        const saleWrap = priceRoot.querySelector('.m-price__sale');
        const regularItem = regularWrap?.querySelector('.m-price-item--regular');
        const saleItem = saleWrap?.querySelector('.m-price-item--sale');
        const crossedItem = saleWrap?.querySelector('.m-price-item--regular');

        if (applied) {
          if (regularWrap) regularWrap.style.display = 'none';
          if (saleWrap) saleWrap.style.display = 'flex';
          if (saleItem) saleItem.textContent = formatMoney(salePrice);
          if (crossedItem) crossedItem.textContent = formatMoney(originalPrice);
          priceRoot.classList.add('m-price--on-sale');
          return;
        }

        if (regularWrap) regularWrap.style.display = '';
        if (saleWrap) saleWrap.style.display = 'none';
        if (regularItem) regularItem.textContent = formatMoney(originalPrice);
        priceRoot.classList.remove('m-price--on-sale');
      };

      const updateOfferPrice = () => {
        const variant = getSelectedVariant();
        if (!variant) return;

        const originalPrice = Number(variant.price);
        const salePrice = Math.round(originalPrice * 0.75);
        const savings = originalPrice - salePrice;
        offer.querySelector('[data-zius-regular-price]').textContent = formatMoney(originalPrice);
        offer.querySelector('[data-zius-promo-price]').textContent = formatMoney(salePrice);
        offer.querySelector('[data-zius-saving]').textContent = formatMoney(savings);
        updateMainPrice(isDiscountApplied, originalPrice, salePrice);
      };

      const params = new URLSearchParams(window.location.search);
      const discountApplied = params.get('discount_applied') === 'NEW25'
        || window.sessionStorage.getItem('zius-new25-applied') === 'true';

      const showAppliedState = () => {
        isDiscountApplied = true;
        note.textContent = 'NEW25 applied ✓';
        applyLink.textContent = 'NEW25 applied ✓';
        applyLink.setAttribute('aria-current', 'true');
        removeButton.hidden = false;
        status.textContent = 'NEW25 is ready and will be applied at checkout.';
        updateOfferPrice();
      };

      const showDefaultState = () => {
        isDiscountApplied = false;
        note.textContent = 'Apply code NEW25 at checkout.';
        applyLink.textContent = 'Apply NEW25';
        applyLink.removeAttribute('aria-current');
        removeButton.hidden = true;
        status.textContent = 'NEW25 removed.';
        updateOfferPrice();
      };

      const updateCartDiscount = (discount) => window.fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount })
      }).then((response) => {
        if (!response.ok) throw new Error('Discount update failed');
        return response.json();
      });

      applyLink?.addEventListener('click', (event) => {
        event.preventDefault();
        if (applyLink.getAttribute('aria-current') === 'true') return;
        window.sessionStorage.setItem('zius-new25-applied', 'true');
        showAppliedState();
        updateCartDiscount('NEW25').catch(() => {
          status.textContent = 'NEW25 is saved. Enter the code at checkout if it is not shown automatically.';
        });
      });

      removeButton?.addEventListener('click', () => {
        removeButton.disabled = true;
        updateCartDiscount('').then(() => {
          window.sessionStorage.removeItem('zius-new25-applied');
          showDefaultState();
        }).catch(() => {
          status.textContent = 'The code could not be removed. Try again.';
        }).finally(() => {
          removeButton.disabled = false;
        });
      });
      if (discountApplied) {
        showAppliedState();
      }

      productSection.addEventListener('change', () => {
        window.setTimeout(() => {
          const variantInput = productSection.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (variantInput?.value) selectedVariantId = String(variantInput.value);
          updateOfferPrice();
        }, 80);
      });

      updateOfferPrice();
      offer.dataset.connected = 'true';
    });
  }

  connectZiusSaleCodes(document);
  document.addEventListener('shopify:section:load', (event) => connectZiusSaleCodes(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zius-selected-configuration"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zius-selected-configuration')) {
    customElements.define('zius-selected-configuration', class extends HTMLElement {
      connectedCallback() {
        this.update = this.update.bind(this);
        document.addEventListener('change', this.update);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.update);
      }

      normalize(name, value) {
        const key = name.toLowerCase();
        const raw = value.trim();
        const lower = raw.toLowerCase();
        if (key.includes('size')) return [];
        if (key === 'metal finish') {
          let metal = raw;
          if (lower.includes('925')) metal = '925 Silver';
          else if (lower.includes('10k')) metal = '10K Gold';
          else if (lower.includes('14k')) metal = '14K Gold';
          else if (lower.includes('18k')) metal = '18K Gold';
          else if (lower.includes('platinum')) metal = 'Platinum';
          const color = lower.includes('rose') ? 'Rose' : lower.includes('yellow') ? 'Yellow' : 'White';
          return [metal, color];
        }
        return [raw];
      }

      update(event) {
        const picker = event.target.closest('variant-picker');
        if (!picker || picker.dataset.sectionId !== this.dataset.sectionId) return;
        queueMicrotask(() => {
          const values = [];
          picker.querySelectorAll('[data-option-name]').forEach((field) => {
            const selected = field.querySelector('select')?.value || field.querySelector('input:checked')?.value || field.dataset.selectedValue;
            if (selected) values.push(...this.normalize(field.dataset.optionName, selected));
          });
          const output = this.querySelector('[data-zius-configuration-text]');
          if (output && values.length) output.textContent = values.join(' · ');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
